<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="授权域名">
                  <el-input style="width: 177px" v-model="queryForm.domainName"></el-input>
              </el-form-item>
              <el-form-item label="软件类型">
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.typeId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option v-for="item in typeList" :label="item.webName" :value="item.id" :key="item.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getApiWebAuthorizeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addApiWebAuthorize"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editApiWebAuthorize(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteApiWebAuthorize(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshApiWebAuthorizeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="apiWebAuthorizeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="domainName"
        label="授权域名"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authorizeCode"
        label="授权码"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authorizeTimeFormatter"
        label="授权过期时间"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="codeError"
        label="版权"
      >
          <template slot-scope="scope">{{scope.row.codeError==0?'正版':'盗版'}}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="typeId"
        label="软件类型"
      >
          <template slot-scope="scope">{{returnType(scope.row.typeId)}}</template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkApiWebAuthorize(scop.row.authorizeId)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editApiWebAuthorize(scop.row.authorizeId)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteApiWebAuthorize(scop.row.authorizeId)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="apiWebAuthorizeStates[apiWebAuthorizeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="apiWebAuthorize"
          ref="apiWebAuthorizeForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="授权域名"
            prop="domainName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiWebAuthorize.domainName"
              :disabled="apiWebAuthorizeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="授权码"
            prop="authorizeCode"
          >
            <div style="width: 177px;display: flex">
                <el-input
                    size="small"
                    v-model="apiWebAuthorize.authorizeCode"
                    :disabled="apiWebAuthorizeState == 'check'"
                ></el-input>
                <el-button
                    type="primary"
                    size="small"
                    style="margin-left: 4px"
                    @click="generateAuthorizeCode"
                    :disabled="apiWebAuthorizeState == 'check'"
                >生成</el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="授权过期时间"
            prop="authorizeTime"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="apiWebAuthorize.authorizeTime"-->
<!--              :disabled="apiWebAuthorizeState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  v-model="apiWebAuthorize.authorizeTimeFormatter"
                  style="width: 177px"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="版权"
            prop="codeError"
          >
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="apiWebAuthorize.codeError"
                  :disabled="apiWebAuthorizeState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option label="正版" :value="0"></el-option>
                  <el-option label="盗版" :value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="软件类型"
            prop="typeId"
          >
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="apiWebAuthorize.typeId"
                  :disabled="apiWebAuthorizeState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option v-for="item in typeList" :label="item.webName" :value="item.id" :key="item.id"></el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="apiWebAuthorizeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetApiWebAuthorizeList();
                    this.getApiWebAuthorizeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetApiWebAuthorizeList();
                    this.getApiWebAuthorizeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     domainName: '', //域名
                     authorizeCode: '', //授权码
                     authorizeTime: '', //授权过期时间
                     codeError: '', //0为正版，1为盗版
                     typeId: '', //网站类型
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                apiWebAuthorizeState: 'add',
                apiWebAuthorizeStates: {
                    add: '新建软件授权',
                    check: '查看软件授权',
                    edit: '修改软件授权'
                },
                typeList: [],
                multipleSelection: [],
                apiWebAuthorizeList: [],
                apiWebAuthorize: {
                    domainName: '', //域名
                    authorizeCode: '', //授权码
                    authorizeTimeFormatter: '',
                    authorizeTime: '', //授权过期时间
                    codeError: '', //0为正版，1为盗版
                    typeId: '', //网站类型
                },
                btnLoading: false,

                rules: {
                    domainName: [{ required: true, message: '域名不能为空', trigger: 'blur' }],
                    authorizeCode: [{ required: true, message: '授权码不能为空', trigger: 'blur' }],
                    authorizeTimeFormatter: [{ required: true, message: '授权过期时间不能为空', trigger: 'blur' }],
                    codeError: [{ required: true, message: '版权不能为空', trigger: 'blur' }],
                    typeId: [{ required: true, message: '软件类型不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getApiWebAuthorizeList();
            this.getTypeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetApiWebAuthorizeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.apiWebAuthorizeList = [];
            },
            // 生成64位授权码
            generateAuthorizeCode(){
                // 定义所有可能的字符集合
                let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';
                for (let i = 0; i < 64; i++) {
                    // 随机选择一个字符添加到结果字符串中
                    result += chars[Math.floor(Math.random() * chars.length)];
                }
                this.apiWebAuthorize.authorizeCode = result;
            },
            getTypeList(){
                get('/biz/apiwebtype/findAll').then(res => {
                    this.typeList = res.list;
                })
            },
            returnType(key){
                for (let item in this.typeList) {
                    if(this.typeList[item].id == key){
                        return this.typeList[item].webName;
                    }
                }
            },
            resetDialog() {
                this.apiWebAuthorizeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      domainName: '', //域名
                      authorizeCode: '', //授权码
                      authorizeTime: '', //授权过期时间
                      codeError: '', //0为正版，1为盗版
                      typeId: '', //网站类型
                };
                this.getApiWebAuthorizeList();
            },
            closeDialog() {
                this.showDialog = false
                this.apiWebAuthorize = {
                      domainName: '', //域名
                      authorizeCode: '', //授权码
                      authorizeTime: '', //授权过期时间
                      authorizeTimeFormatter: '',
                      codeError: '', //0为正版，1为盗版
                      typeId: '', //网站类型
                };
            },
            submitForm() {
                if (this.apiWebAuthorizeState == 'add') {
                    this.$refs.apiWebAuthorizeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            this.apiWebAuthorize.authorizeTime = new Date(this.apiWebAuthorize.authorizeTimeFormatter).getTime() / 1000;
                            post(`/biz/apiwebauthorize/add`,{ ...this.apiWebAuthorize }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetApiWebAuthorizeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.apiWebAuthorizeState == 'edit') {
                    this.$refs.apiWebAuthorizeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            this.apiWebAuthorize.authorizeTime = new Date(this.apiWebAuthorize.authorizeTimeFormatter).getTime() / 1000;
                            post(`/biz/apiwebauthorize/edit`,{ ...this.apiWebAuthorize }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetApiWebAuthorizeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addApiWebAuthorize() {
                this.showDialog = true;
                this.apiWebAuthorizeState = 'add';
            },
            checkApiWebAuthorize(apiWebAuthorizeId) {
                console.log(apiWebAuthorizeId);
                this.currentApiWebAuthorizeId = apiWebAuthorizeId;

                this.getApiWebAuthorizeById();
                this.showDialog = true;
                this.apiWebAuthorizeState = 'check';
            },
            editApiWebAuthorize(apiWebAuthorizeId) {
                console.log('apiWebAuthorize', apiWebAuthorizeId);
                if (apiWebAuthorizeId) {
                    this.currentApiWebAuthorizeId = apiWebAuthorizeId;
                    this.getApiWebAuthorizeById();
                } else {
                    this.apiWebAuthorize = { ...this.apiWebAuthorize, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.apiWebAuthorizeState = 'edit';
            },
            deleteApiWebAuthorize(apiWebAuthorizeId) {
                let ids = '';
                if (apiWebAuthorizeId) {
                    ids = apiWebAuthorizeId;
                } else {
                    ids = this.multipleSelection.map((apiWebAuthorize) => apiWebAuthorize.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/biz/apiwebauthorize/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetApiWebAuthorizeList();
                                this.getApiWebAuthorizeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshApiWebAuthorizeList() {
                this.resetApiWebAuthorizeList();
                this.getApiWebAuthorizeList();
            },
            getApiWebAuthorizeList(query = {}) {
                this.loading = true;
                get(`/biz/apiwebauthorize/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.apiWebAuthorizeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getApiWebAuthorizeById() {
                get(`/biz/apiwebauthorize/get`,{ id: this.currentApiWebAuthorizeId }).then((res) =>{
                    if(res.success){
                      this.apiWebAuthorize = { ...this.apiWebAuthorize, ...res.apiWebAuthorize };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportApiWebAuthorizeList() {
                //this.btnLoading = true;
                exprotExcel(`/biz/apiwebauthorize/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/biz/apiwebauthorize/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/biz/apiwebauthorize/importData`,formData);
              this.refreshApiWebAuthorizeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getApiWebAuthorizeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getApiWebAuthorizeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>